import { css, keyframes } from '@emotion/react';

import { PopoverProps } from './';
import { hexToRgba } from '@utils/view-layer/colors';
import styled from '@emotion/styled/macro';
import { ThemeColors } from '@theme/foundations/colors';

const ARROW_SIZE = 12;

const overlayAnimation = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const modalAnimation = keyframes`
  0% {
    opacity: 0;
    /* transform: translate3d(0, 1rem, 0); */
  }
  100% {
    opacity: 1;
    /* transform: translate3d(0, 0, 0); */
  }
`;

const containerDisplay = (center?: boolean) => {
  if (center) {
    return css`
      align-items: center;
      display: flex;
      justify-content: center;
    `;
  }
};

const StyledTooltipArrow = styled.div<{ borderColor?: string }>`
  background: inherit;
  height: ${ARROW_SIZE}px;
  position: absolute;
  visibility: hidden;
  width: ${ARROW_SIZE}px;

  &::before {
    background: inherit;
    content: "";
    height: ${ARROW_SIZE}px;
    position: absolute;
    transform: rotate(45deg);
    width: ${ARROW_SIZE}px;
    visibility: visible;
    border-color: ${({ borderColor }) =>
      borderColor || ThemeColors.neutral['400']};
  }
`;

const StyledOffscreenContainer = styled.div<PopoverProps>`
  ${(props) => containerDisplay(props.isFullscreenCentered)}
  height: ${(props) => (props.renderMethod === 'fullscreen' ? '100%' : null)};
  border-width: ${({ borderWidth }) => borderWidth || 1}px;
  border-color: ${({ borderColor }) =>
    borderColor || ThemeColors.neutral['400']};
  padding: ${({ arrow }) => (arrow ? 8 : 0)}px;
  box-shadow: 0px 4px 64px rgba(119, 130, 149, 0.1);
  background: white;
  border-radius: 8px;
  overflow: hidden;

  &[data-popper-placement^="top"] > ${StyledTooltipArrow} {
    bottom: ${(ARROW_SIZE * -1) / 2}px;

    &::before {
      border-bottom-width: ${({ borderWidth }) => borderWidth || 1}px;
      border-right-width: ${({ borderWidth }) => borderWidth || 1}px;
    }
  }

  &[data-popper-placement^="bottom"] > ${StyledTooltipArrow} {
    top: ${(ARROW_SIZE * -1) / 2}px;

    &::before {
      border-top-width: ${({ borderWidth }) => borderWidth || 1}px;
      border-left-width: ${({ borderWidth }) => borderWidth || 1}px;
    }
  }

  &[data-popper-placement^="left"] > ${StyledTooltipArrow} {
    right: ${(ARROW_SIZE * -1) / 2}px;

    &::before {
      border-top-width: ${({ borderWidth }) => borderWidth || 1}px;
      border-right-width: ${({ borderWidth }) => borderWidth || 1}px;
    }
  }

  &[data-popper-placement^="right"] > ${StyledTooltipArrow} {
    left: ${(ARROW_SIZE * -1) / 2}px;

    &::before {
      border-bottom-width: ${({ borderWidth }) => borderWidth || 1}px;
      border-left-width: ${({ borderWidth }) => borderWidth || 1}px;
    }
  }
`;

const StyledOffscreenFullInner = styled.div<{
  isCentered?: boolean;
  pinTo?: 'bottom' | 'top' | 'left';
}>`
  animation: ${modalAnimation} 0.2s 0.2s ease-in forwards;
  opacity: 0;
  position: absolute;
  ${({ pinTo }) => {
    if (pinTo === 'bottom') {
      return css`
        bottom: 0;
      `;
    }
    return css`
      top: 0;
    `;
  }}
  width: 100%;
`;

const StyledOffscreenFullOutter = styled.div<{ isCentered?: boolean }>`
  display: flex;
  height: 100%;
  position: fixed;
  width: 100%;
  z-index: 9999;
`;

const StyledOffscreenFullWrap = styled.div`
  bottom: 0;
  height: 100vh;
  left: 0;
  right: 0;
  top: 0;
  width: 100vw;
  z-index: 999;
`;

const StyledOffscreenOverlay = styled.div`
  animation: ${overlayAnimation} 0.3s forwards;
  background-color: ${hexToRgba('#252525', 0.8)};
  bottom: 0;
  height: 100%;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
`;

const StyledOffscreen = styled.div``;

export {
  StyledOffscreen,
  StyledOffscreenContainer,
  StyledOffscreenFullInner,
  StyledOffscreenFullOutter,
  StyledOffscreenFullWrap,
  StyledOffscreenOverlay,
  StyledTooltipArrow,
};
